import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';

export type TDialSuggestionSource = 'psa' | 'history';

export interface IDialSuggestion {
  name: string;
  phoneE164: string;
  contactExternalId?: string | null;
  companyExternalId?: string | null;
  crmSourceId?: number | null;
  source: TDialSuggestionSource;
}

export interface IDialSuggestionsQuery {
  crmSourceId: number;
  countryCode: string;
  digits: string;
  limit: number;
}

export const getDialSuggestions = (params: IDialSuggestionsQuery): IResponse<IDialSuggestion[]> =>
  axiosInstance.request({
    method: 'GET',
    url: 'call-scribe/dial-suggestions',
    params,
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    skipErrorSnackbar: true,
  });
